var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('div',{staticClass:"body"},[_c('video',{ref:"player",staticClass:"video-js video",attrs:{"playsinline":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }